import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_SCHEDULED_JOB_TYPE_URL } from '../../core.global';
import { BasicService } from '../../_base/services/basic.service';

@Injectable()
export class ScheduledJobTypeService extends BasicService{
    baseUrl:string = '';
    
    constructor(protected http: HttpClient){
        super(http);
        this.baseUrl = API_SCHEDULED_JOB_TYPE_URL;
    }
}